// @flow

import { useNavigation } from '@react-navigation/native';
import * as React from 'react';
import {
    View,
    TextInput,
    useWindowDimensions,
    Linking, Pressable, ActivityIndicator,
} from 'react-native';
import { FormattedMessage, useIntl } from 'react-intl';
import { APIContext } from 'speed-js-react';

import { setPermissions, setUser } from 'speed-js-react/src/redux/auth/actions';
import { useDispatch } from 'react-redux';
import { PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';
import Text from 'src/components/CustomText/CustomText';
import { HOME_SCREEN, MYCOOOLBOX_URL } from 'src/navigation/constants';
import StyledButton from 'src/components/StyledButton/StyledButton';
import styles from 'src/navigation/Login/LoginStyles';
import LoginIcon from 'src/Icons/LoginIcon';
import { navigateWithoutHistory } from 'src/navigation/Stack';
import { commonStyles } from 'src/styles/common';
import MainWrapper from 'src/components/MainWrapper';

const Login = () => {
    const { apiClient } = React.useContext(APIContext);
    const { width } = useWindowDimensions();
    const intl = useIntl();
    const navigation = useNavigation();
    const dispatch = useDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    const tokenValue = urlParams.get('token');

    const [showIndicator, setShowIndicator] = React.useState(false);
    const [loggingIn, setLoggingIn] = React.useState(false);
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [errors, setErrors] = React.useState(null);

    React.useEffect(() => {
        document.getElementById('page-description').setAttribute('content', `
        Портал за управление и персонализиране на достъпа до приложението.
        `);
    }, []);

    React.useEffect(() => {
        const { pathname } = window.location;

        let pathnameToSet = pathname;
        const prefix = `${process.env.PUBLIC_URL}/`.replace('//', '/');

        if (pathnameToSet !== `${prefix}home` && pathnameToSet !== `${prefix}login` && pathnameToSet !== prefix) {
            while (pathnameToSet.startsWith('/')) {
                pathnameToSet = pathnameToSet.slice(1);
            }
            sessionStorage.setItem('prev_url', pathnameToSet);
        }
        if (tokenValue) {
            setShowIndicator(true);
        }
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        if (tokenValue) {
            setShowIndicator(true);
            apiClient.resources.autoLogin.login({ token: tokenValue })
                .then((res) => {
                    const {
                        token: {
                            access: accessToken, refresh: refreshToken,
                        },
                        account_id: account,
                    } = res;

                    if (!localStorage.getItem('account')) {
                        localStorage.setItem('account', account);
                    }

                    apiClient.auth.setRefreshToken(refreshToken);
                    apiClient.auth.accessToken = accessToken;
                    dispatch(setUser(res.user));
                    dispatch(setPermissions(res.user.permissions));
                    navigateWithoutHistory(navigation, HOME_SCREEN);
                })
                .catch(() => {
                    setShowIndicator(false);
                });
        }
    }, [apiClient.auth, apiClient.resources.autoLogin, dispatch, navigation, tokenValue]);

    const onSubmitHandler = () => {
        const credentials = {
            username,
            password,
        };
        setLoggingIn(true);
        apiClient.authorize(credentials)
            .then(({ data }) => {
                const { user } = data;
                dispatch(setUser(user));
                dispatch(setPermissions(user.permissions));
                setLoggingIn(false);
                // navigateWithoutHistory(navigation, HOME_SCREEN);
            })
            .catch((err) => {
                if (err.data) {
                    setErrors(err.data[0]);
                }
                setLoggingIn(false);
            });
    };
    if (showIndicator) {
        return (
            <MainWrapper>
                <ActivityIndicator
                    size="large"
                    color={PRIMARY_COLOR}
                />
            </MainWrapper>
        );
    }

    return (
        <MainWrapper>
            <View style={width > 600 ? styles.second_wrapper : styles.second_wrapper_phone}>
                <Text style={width < 600 ? styles.login_label_phone : styles.login_label}>
                    <FormattedMessage
                        id="login-to-your-account"
                        defaultMessage="Login To Your Account:"
                    />
                    <Pressable
                        onPress={() => {
                            Linking.openURL(MYCOOOLBOX_URL);
                        }}
                    >
                        <Text
                            style={width > 600 ? styles.my_cooolbox_link : styles.my_cooolbox_link_phone}

                        >
                            my.cooolbox.bg
                        </Text>
                    </Pressable>
                </Text>
                <View style={width > 600 ? styles.third_wrapper : styles.third_wrapper_phone}>
                    <View style={width > 600 ? styles.login_container : styles.login_container_phone}>
                        <View style={width > 600 ? styles.image_wrapper : styles.image_wrapper_phone}>
                            <LoginIcon />
                        </View>
                        <View style={styles.input_wrapper}>
                            <TextInput
                                style={width > 600 ? commonStyles.input : commonStyles.input_phone}
                                placeholder={(
                                    intl.formatMessage({ id: 'email', defaultMessage: 'Email' })
                                )}
                                onSubmitEditing={onSubmitHandler}
                                onChangeText={(el) => setUsername(el)}
                            />
                            <TextInput
                                style={width > 600 ? commonStyles.input : commonStyles.input_phone}
                                placeholder={(
                                    intl.formatMessage({ id: 'password', defaultMessage: 'Password' })
                                )}
                                onSubmitEditing={onSubmitHandler}
                                onChangeText={(el) => setPassword(el)}
                                secureTextEntry
                                autoCorrect={false}
                            />
                            {errors && <View><Text style={commonStyles.error}>{errors}</Text></View> }
                            <StyledButton
                                handleSubmit={onSubmitHandler}
                                text={
                                    <FormattedMessage id="login" defaultMessage="Login" />
                                }
                                loading={loggingIn}
                            />
                        </View>
                    </View>
                </View>
                <View style={styles.messageWrapper}>
                    <View style={styles.message}>
                        <Text style={width < 600 ? styles.messageTextMobile : styles.messageText}>
                            Достъпът до портала за управление е възможен само при наличието на активна услуга
                            <Pressable
                                onPress={() => { window.open('https://coool.tv/'); }}
                            >
                                <Text style={styles.my_cooolbox_link}> coool.tv</Text>
                            </Pressable>
                            . Ако желаете да се възползвате от 3-дневен пробен период на
                            <Pressable
                                onPress={() => { window.open('https://coool.tv/'); }}
                            >
                                <Text style={styles.my_cooolbox_link}> coool.tv</Text>
                            </Pressable>
                            , моля влезте в портала с потребителското си име и парола от
                            <Pressable onPress={() => { window.open('https://my.cooolbox.bg/'); }}>
                                <Text style={styles.my_cooolbox_link}> my.cooolbox.bg</Text>
                            </Pressable>
                            . Ако желаете да се абонирате за услугата
                            <Pressable
                                onPress={() => { window.open('https://coool.tv/'); }}
                            >
                                <Text style={styles.my_cooolbox_link}> coool.tv</Text>
                            </Pressable>
                            , е необходимо да я активирате през клиентския портал
                            <Pressable onPress={() => { window.open('https://my.cooolbox.bg/'); }}>
                                <Text style={styles.my_cooolbox_link}> my.cooolbox.bg</Text>
                            </Pressable>
                            {/* eslint-disable-next-line max-len */}
                            , без посещение, по всяко време на денонощието. Тя се предоставя като допълнителна услуга към
                            <Pressable
                                onPress={() => { window.open('https://www.cooolbox.bg/za-doma/cooolNet'); }}
                            >
                                <Text style={styles.my_cooolbox_link}> cooolNet</Text>
                            </Pressable>
                            .
                        </Text>
                    </View>
                </View>
            </View>
        </MainWrapper>
    );
};

export default Login;
